export default "__VITE_ASSET__DV3hvAU3__"